import { Modal } from 'react-bootstrap';
import type { VoidFunctionComponent } from 'react';
import { useCallback } from 'react';
import { CheckEmailStepBody } from './Google/ClaimDomainModal/CheckEmailStep';
import { window } from '../../../../../globals';
import Loader from '../../../../generic/Loader';
import { useResendingEmailTokenIds, usePendingDomains } from './hooks';

type Props = {
  isOpen: boolean;
  onHide: () => void;
  domain: string;
};

const CheckEmailModal: VoidFunctionComponent<Props> = ({ isOpen, onHide, domain }) => {
  const organizationId = window.user?.organizationId as number;
  const { isLoading, value: pendingDomains } = usePendingDomains(window.user?.organizationId as number);
  const { resendEmailToken } = useResendingEmailTokenIds(organizationId);

  const resendVerificationEmail = useCallback(
    (authedDomain: string) => {
      const pendingToken = (pendingDomains || []).find(({ meta }) => meta.emailDomain === authedDomain);
      if (!pendingToken) {
        return null;
      }

      return resendEmailToken(pendingToken.id);
    },
    [pendingDomains, resendEmailToken],
  );

  return (
    <Modal show={isOpen} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Claim New Domain</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isLoading ? (
          <Loader />
        ) : (
          <CheckEmailStepBody
            domain={domain}
            resendEmail={() => {
              resendVerificationEmail(domain);
            }}
          />
        )}
      </Modal.Body>
    </Modal>
  );
};

export default CheckEmailModal;
